import { uidHandler } from '@/lib/uidHandler';
import { Route } from 'vue-router';

export const getYmhFromQuery = ( route: Route ): string => {

    const rawData = route.query['ymh'];
    if ( typeof rawData === 'string' && rawData !== '' ) {

        return uidHandler.decrypt( rawData );

    }

    return '';

};
